import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "icon", "title", "disabled", "className"];
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import React from 'react';
import { Avatar } from "../../Avatar";
import { Text } from "../../Text";
import styles from "./styles.pcss";
var cnCellGrid = cnBem('cell-grid', styles);
export var CellGrid = forwardRefWithTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    icon = props.icon,
    title = props.title,
    disabled = props.disabled,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnCellGrid(null, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "Cell-CellGrid"
  }), /*#__PURE__*/React.createElement(Avatar, {
    disabled: disabled,
    icon: icon,
    size: "m",
    "data-t-id": "Cell-CellGrid"
  }), /*#__PURE__*/React.createElement(Text, {
    align: "center",
    color: disabled ? 'disabled' : 'secondary',
    variant: "caption-medium"
  }, title));
});